module.exports = __webpack_public_path__ + "static/media/nursing-photo.534beb25.jpeg";